import React from 'react'
import { CFooter } from '@coreui/react'
// import logos from "../assets/qdegreesLogo.png";
// import CIcon from '@coreui/icons-react'

const TheFooter = () => {
  return (
    <CFooter fixed={false}>
      <div>
        <a href="https://www.qdegrees.com/" target="_blank" rel="noopener noreferrer"></a>
        
      </div>
      <div className="mfs-auto">
        <span className="mr-1">© Copyright Powered by <span style={{color:"blue"}}>QDegrees</span>.com</span>
        {/* <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">CoreUI for React</a> */}
      </div>
    </CFooter>
  )
}

export default React.memo(TheFooter)
